export default __webpack_public_path__ + "images/black-wine.png";